import React from 'react';
import PropTypes from 'prop-types';
import { UploadItemCard } from './UploadItemCard';

export function UploadListSection({
  items,
  panelStyle,
  interactionLocked,
  isUploadBlockedByCaseStatus,
  transcriptAccept,
  getMediaSizeText,
  getPresentation,
  onDescriptionChange,
  onMediaDelete,
  onTranscriptToggle,
  onTranscriptFileChange,
  onBrowseTranscript,
  onTranscriptDescriptionChange,
  onTranscriptDelete,
  setTranscriptInputRef,
  renderDebug
}) {
  if (!items || items.length <= 0) {
    return null;
  }

  return (
    <div className="upload-list-shell" style={panelStyle}>
      {renderDebug ? renderDebug(items) : null}
      {items.map((item) => (
        <UploadItemCard
          key={item.id}
          item={item}
          mediaSizeText={getMediaSizeText(item)}
          interactionLocked={interactionLocked}
          isUploadBlockedByCaseStatus={isUploadBlockedByCaseStatus}
          transcriptAccept={transcriptAccept}
          presentation={getPresentation(item)}
          onDescriptionChange={onDescriptionChange}
          onMediaDelete={onMediaDelete}
          onTranscriptToggle={onTranscriptToggle}
          onTranscriptFileChange={onTranscriptFileChange}
          onBrowseTranscript={() => onBrowseTranscript(item)}
          onTranscriptDescriptionChange={onTranscriptDescriptionChange}
          onTranscriptDelete={onTranscriptDelete}
          setTranscriptInputRef={(element) => setTranscriptInputRef(item, element)}
        />
      ))}
    </div>
  );
}

const filePropType = PropTypes.shape({
  name: PropTypes.string
});

const uploadItemPropType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mediaFile: filePropType,
  mediaUploadStatus: PropTypes.string,
  description: PropTypes.string,
  transcriptEnabled: PropTypes.bool,
  transcriptFile: filePropType,
  transcriptUploadStatus: PropTypes.string,
  transcriptDescription: PropTypes.string
});

UploadListSection.propTypes = {
  items: PropTypes.arrayOf(uploadItemPropType).isRequired,
  panelStyle: PropTypes.object,
  interactionLocked: PropTypes.bool.isRequired,
  isUploadBlockedByCaseStatus: PropTypes.bool.isRequired,
  transcriptAccept: PropTypes.string.isRequired,
  getMediaSizeText: PropTypes.func.isRequired,
  getPresentation: PropTypes.func.isRequired,
  onDescriptionChange: PropTypes.func.isRequired,
  onMediaDelete: PropTypes.func.isRequired,
  onTranscriptToggle: PropTypes.func.isRequired,
  onTranscriptFileChange: PropTypes.func.isRequired,
  onBrowseTranscript: PropTypes.func.isRequired,
  onTranscriptDescriptionChange: PropTypes.func.isRequired,
  onTranscriptDelete: PropTypes.func.isRequired,
  setTranscriptInputRef: PropTypes.func.isRequired,
  renderDebug: PropTypes.func
};
